import { createAction } from "@reduxjs/toolkit";

import type {
  PutApplicationMetadataUpdateRequestBody,
  PutApplicationUpdateRequestBody,
} from "@superblocksteam/schemas";
import type {
  ActionTypeEnum,
  ApplicationConfiguration,
  ApplicationSettings,
  ApplicationV2GlobalDto,
} from "@superblocksteam/shared";

import type { UpdateNonVersionedApplicationSettingsPayload } from "legacy/api/ApplicationApi";
import type ApplicationApi from "legacy/api/ApplicationApi";
import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";
import type { Page } from "legacy/constants/ReduxActionConstants";

import type { APP_MODE } from "../../../legacy/reducers/types";

export const fetchApplicationPermissions = createAction(
  "fetchApplicationPermissions/start",
  (applicationId: string) => ({ payload: { applicationId } }),
);

export const fetchApplicationPermissionsSuccess = createAction(
  "fetchApplicationPermissions/success",
  (permissions: Array<ActionTypeEnum>) => ({ payload: { permissions } }),
);

export const fetchApplicationPermissionsError = createAction(
  "fetchApplicationPermissions/error",
  (error: string) => ({ payload: { error } }),
);

export const fetchApplication = createAction(
  "FETCH_APPLICATION_INIT",
  (
    applicationId: string,
    mode: APP_MODE,
    branch: string | undefined,
    commitId?: string,
  ) => ({
    payload: {
      applicationId,
      mode,
      branch,
      commitId,
    },
  }),
);

export const fetchApplicationSuccess = createAction(
  "FETCH_APPLICATION_SUCCESS",
  (
    application: Awaited<
      ReturnType<typeof ApplicationApi.fetchSingleApplication>
    >["data"]["application"] & {
      global?: Partial<ApplicationV2GlobalDto>;
    },
  ) => ({ payload: application }),
);

export const updateApplication = createAction(
  "UPDATE_APPLICATION",
  (
    id: string,
    branch: string | undefined,
    data: Partial<PutApplicationUpdateRequestBody>,
  ) => {
    return {
      payload: {
        id,
        branch,
        ...data,
      },
    };
  },
);

export const updateApplicationSettings = createAction<ApplicationSettings>(
  "CURRENT_APPLICATION_SETTINGS_UPDATE",
);

export const doneRefactoringAppConfiguration =
  createAction<ApplicationConfiguration>(
    "application/doneRefactoringAppConfiguration",
  );

export const requestApplicationSave = createAction("REQUEST_APPLICATION_SAVE");

export const updateNonVersionedApplicationSettings =
  createAction<UpdateNonVersionedApplicationSettingsPayload>(
    "UPDATE_NON_VERSIONED_APPLICATION_SETTINGS",
  );

export const updateApplicationMetadata = createAction(
  "UPDATE_APPLICATION_METADATA",
  (
    id: string,
    data: PutApplicationMetadataUpdateRequestBody,
    disableNotification?: boolean,
  ) => ({
    payload: { id, ...data, disableNotification },
  }),
);

export const fetchPageListSuccess = createAction(
  ReduxActionTypes.FETCH_PAGE_LIST_SUCCESS,
  (payload: { pages: Page[]; applicationId: string }) => ({ payload }),
);
